export const FETCH_ALARMS_REQUEST = 'FETCH_ALARMS_REQUEST';
export const FETCH_ALARMS_SUCCESS = 'FETCH_ALARMS_SUCCESS';
export const FETCH_ALARMS_FAILED = 'FETCH_ALARMS_FAILED';

export const FETCH_ALARM_BY_ID_REQUEST = 'FETCH_ALARMS_BY_ID_REQUEST';
export const FETCH_ALARM_BY_ID_SUCCESS = 'FETCH_ALARMS_BY_ID_SUCCESS';
export const FETCH_ALARM_BY_ID_FAILED = 'FETCH_ALARMS_BY_ID_FAILED';

export const FETCH_ALARMS_TYPES_REQUEST = 'FETCH_ALARMS_TYPES_REQUEST';
export const FETCH_ALARMS_TYPES_SUCCESS = 'FETCH_ALARMS_TYPES_SUCCESS';
export const FETCH_ALARMS_TYPES_FAILED = 'FETCH_ALARMS_TYPES_FAILED';

export const FETCH_UPDATE_ALARM_REQUEST = 'FETCH_UPDATE_ALARM_REQUEST';
export const FETCH_UPDATE_ALARM_SUCCESS = 'FETCH_UPDATE_ALARM_SUCCESS';
export const FETCH_UPDATE_ALARM_FAILED = 'FETCH_UPDATE_ALARM_FAILED';

export const FETCH_UPDATE_ALARMS_STATUS_REQUEST = 'FETCH_UPDATE_ALARMS_STATUS_REQUEST';
export const FETCH_UPDATE_ALARMS_STATUS_SUCCESS = 'FETCH_UPDATE_ALARMS_STATUS_SUCCESS';
export const FETCH_UPDATE_ALARMS_STATUS_FAILED = 'FETCH_UPDATE_ALARMS_STATUS_FAILED';
